import { useState, useEffect, useMemo } from "react";
import HomeSectionCard from "../HomeSectionCard/HomeSectionCard";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductsByGrandParentCategory } from "../../State/Product/Action";
import { CustomNextArrow, CustomPrevArrow } from "../Home/SettingsAndArrows";
import Slider from "react-slick";

const MatchingOutfitCarousel = ({ productId, title, color, category, subCategory, productCategory }) => {
  const dispatch = useDispatch();
  const { products } = useSelector((store) => store);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    dispatch(getAllProductsByGrandParentCategory(category));
  }, [dispatch, category]);

  // Memoized filtered items for better performance
  const items = useMemo(() => {
    return (
      products?.products?.response?.filter((item) => {
        // Match category and product category
        const notMatchProductId = item?.id !== productId;
        const matchesCategory = item.category?.name === category;
        const matchesProductCategory = item.productCategory?.name === productCategory;

        // Match color (if provided)
        const matchesColor = !color || item.colors?.some(c =>
          c.color?.name?.toLowerCase() === color.toLowerCase()
        );

        return notMatchProductId && matchesCategory && matchesProductCategory && matchesColor;
      }) || []
    );
  }, [products?.products?.response, productId, category, productCategory, color]);


  // Ensure at least 3 slots are always present
  while (items.length < 4 && items.length > 0) {
    items.push(
      <div key={`placeholder-${items.length}`} className="opacity-0">
        Placeholder
      </div>
    );
  }


  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 3,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    prevArrow: <CustomPrevArrow currentSlide={currentSlide} />,
    nextArrow: (
      <CustomNextArrow
        currentSlide={currentSlide}
        slideCount={items?.length || 0}
      />
    ),
    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 4, slidesToScroll: 3 },
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4, slidesToScroll: 3 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, slidesToScroll: 2 },
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 2.5, slidesToScroll: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 360,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  };
  return (
    items.length > 0 && (
      <div className="bg-white pt-4">
        <section className="justify-start">
          <div className="max-w-7xl mx-auto px-[0.25%]">
            <div className="flex justify-between items-center mb-4 px-1 sm:px-2 md:px-0">
              <h2
                className="font-bold text-gray-900 uppercase"
                style={{ fontSize: "clamp(1.1rem, 2.5vw, 1.4rem)", }}
              >
                {title}
              </h2>
              <a
                href={`/${category}/${subCategory}/${productCategory}?color=${color}`}
                className="text-gray-600 hover:text-gray-700 font-normal text-xs uppercase transition-colors duration-300"
              >
                VIEW ALL
              </a>
            </div>

            {/* Enhanced Product Carousel */}
            <div className="relative">
              <div className="w-full relative overflow-hidden px-1 sm:px-2 md:px-0">
                <Slider {...settings}>
                  {items?.map((product) => (
                    <div key={product.id}>
                      <HomeSectionCard product={product} />
                    </div>
                  ))}
                </Slider>
              </div>

              {/* Section Decoration */}
              <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2">
                <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-red-600 rounded-full"></div>
              </div>
            </div>
          </div>
        </section>
        <style>
          {`
            .slick-slide > div {
              margin: 0 8px; /* ✅ gap between products */
            }
            .slick-list {
              margin: 0 -8px; /* ✅ remove extra space from edges */
            }
          `}
        </style>
      </div>
    )
  );
};

export default MatchingOutfitCarousel;
